import script from "./nearLiveV2.vue?vue&type=script&setup=true&lang=js"
export * from "./nearLiveV2.vue?vue&type=script&setup=true&lang=js"

import "./nearLiveV2.vue?vue&type=style&index=0&id=1b2a07b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b2a07b8"]])

export default __exports__